import React from 'react';
import styled from 'styled-components';
import LogoBar from './logoBar';
import MainNav from './mainNav';
import SubCategoires from './subCategoires';
import { CONSTS } from '../elements/_constants';
import { AppState } from '../../store';
import { setMenuStatus } from '../../store/base/functions';
import { connect } from 'react-redux';

type navigationProps = {
    className?: string,
    currentCategoryId: number,
    onSetMenuStatus: Function,
    isMainMenuOpen: boolean,
}

const NavigationComponent = (props: navigationProps) => {
    return (
        <div className={props.className}>
            <LogoBar/>
            <div className="nav-bottom-bar">
                <MainNav/>
                <SubCategoires/>
            </div>
        </div>
    )
}

const Navigation = styled(NavigationComponent)`
    height: 100vh;
    width: 300px;
    background:white;
    box-shadow: 0 0 0 1px rgba(63,63,68,0.05);
    .nav-bottom-bar {
        display: flex;
        height: calc(100% - 60px);
        flex-direction: row;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            display: ${props => props.isMainMenuOpen ? 'flex' : 'none'};
        }
    }
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        height: ${props => props.isMainMenuOpen ? '100vh' : 'auto'};
        position: fixed;
        width: 100%;
        z-index: 11111111;
    }
`
const StyledBottomBar = styled.div`
`
const mapStateToProps = (state: AppState) => ({
    isMainMenuOpen: state.base.isMainMenuOpen
});
  
const mapDispatchToProps = (dispatch:any) => {
    return {
        onSetMenuStatus: (isOpen: boolean)=>{
            dispatch(setMenuStatus(isOpen));
        },
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Navigation);